import { useState } from "react";
import moment from "moment";

const AppointmentTabItem = ({ status, date, time, duration, notes }) => {
  // Function to get status badge styling
  const getStatusBadgeStyle = (status) => {
    const baseStyle = {
      padding: "4px 8px",
      borderRadius: "60px",
      fontSize: "11px",
      fontWeight: 500,
      fontFamily: "Inter",
      textAlign: "center",
      minWidth: "80px"
    };

    switch (status) {
      case "Cancelled":
        return {
          ...baseStyle,
          backgroundColor: "#FEE4E2",
          color: "#D92D20"
        };
      case "Completed":
        return {
          ...baseStyle,
          backgroundColor: "#DCFAE6",
          color: "#079455"
        };
      case "Upcoming":
        return {
          ...baseStyle,
          backgroundColor: "#ece8f2",
          color: "#654e89"
        };
      default:
        return {
          ...baseStyle,
          backgroundColor: "#F3F4F6",
          color: "#6B7280"
        };
    }
  };

  return (
    <div 
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px 20px",
        backgroundColor: "#FFFFFF",
        border: "1px solid #E5E7EB",
        borderRadius: "8px",
        marginBottom: "8px",
        fontFamily: "Inter"
      }}
    >
      {/* Status Column */}
      <div style={{ minWidth: "100px" }}>
        <span style={getStatusBadgeStyle(status)}>
          {status}
        </span>
      </div>
      
      {/* Date Column */}
      <div 
        style={{
          color: "#6B7280",
          fontSize: "13px",
          fontWeight: 400,
          fontFamily: "Inter",
          minWidth: "100px",
          textAlign: "center"
        }}
      >
        {date}
      </div>

      {/* Time Column */}
      <div 
        style={{
          color: "#6B7280",
          fontSize: "13px",
          fontWeight: 400,
          fontFamily: "Inter",
          minWidth: "80px",
          textAlign: "center"
        }}
      >
        {time}
      </div>

      {/* Duration Column */}
      <div 
        style={{
          color: "#6B7280",
          fontSize: "13px",
          fontWeight: 400,
          fontFamily: "Inter",
          minWidth: "80px",
          textAlign: "right"
        }}
      >
        {duration}
      </div>
    </div>
  );
};

export default AppointmentTabItem;
